module.exports = __webpack_public_path__ + "static/profil_koncoworoczny_2021_21-d2c34720f85d939beecb63c073e54893.jpg";